import korzaLogoWhite from '@/assets/korza_logo_white.png';
import { useI18nContext } from '@/i18n/i18n-react';
import { LanguageSelector } from './language-selector';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { useSelfQuery } from '@/hooks/use-self';

export interface SignupHeaderProps {
  backLink?: string;
  actions?: React.ReactNode;
  className?: string;
}

export function FixedHeader({
  backLink,
  actions,
  className,
}: SignupHeaderProps) {
  const { LL } = useI18nContext();
  const [scrolled, setScrolled] = useState(false);

  // Can't use useSelf here because this is used in places that don't require authentication
  const selfUser = useSelfQuery();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 w-full right-0 p-4 bg-background flex flex-row items-center z-10 transition-colors duration-300 ${
        scrolled ? 'border-b border-border' : 'border-b border-transparent'
      } ${className}`}
    >
      {backLink && (
        <Link
          to={backLink}
          className="text-muted-foreground hover:text-foreground transition-colors mr-4"
        >
          <ChevronLeft className="h-6 w-6" />
        </Link>
      )}
      <img
        src={korzaLogoWhite}
        alt={LL.signupHeader.logoAlt()}
        className="h-5 object-contain"
      />
      <div className="flex-1"></div>
      {selfUser.data && (
        <div className="text-muted-foreground text-sm">
          {LL.common.loggedInAs({
            email: selfUser.data.email,
          })}
        </div>
      )}
      {actions}
      <LanguageSelector className="max-w-[75px] md:max-w-[150px] justify-self-end ml-2" />
    </div>
  );
}
